// Follow-up Status Options
export const FOLLOW_UP_STATUS_OPTIONS = [
    { label: 'Pending', value: 'PENDING' },
    { label: 'Done', value: 'DONE' },
    { label: 'Cancelled', value: 'CANCELLED' },
    { label: 'Missed', value: 'MISSED' },
] as const;

// Follow-up Type Options
export const FOLLOW_UP_TYPE_OPTIONS = [
    { label: 'Appointment', value: 'APPOINTMENT' },
    { label: 'Patient', value: 'PATIENT' },
    { label: 'Lead', value: 'LEAD' },
    { label: 'Feedback', value: 'FEEDBACK' },
] as const;

// Follow-up Outcome Options - Type Specific
export const LEAD_OUTCOME_OPTIONS = [
    { label: 'Follow up', value: 'FOLLOW_UP' },
    { label: 'Need Time', value: 'NEED_TIME' },
    { label: 'Interested', value: 'INTERESTED' },
    { label: 'Not Interested', value: 'NOT_INTERESTED' },
    { label: 'No Response', value: 'NO_RESPONSE' },
    { label: 'Not Reachable', value: 'NOT_REACHABLE' },
] as const;

export const FEEDBACK_OUTCOME_OPTIONS = [
    { label: 'Good', value: 'GOOD' },
    { label: 'Bad', value: 'BAD' },
    { label: 'No Response', value: 'NO_RESPONSE' },
    { label: 'Not Reachable', value: 'NOT_REACHABLE' },
] as const;

export const APPOINTMENT_OUTCOME_OPTIONS = [
    { label: 'Need Time', value: 'NEED_TIME' },
    { label: 'No Response', value: 'NO_RESPONSE' },
    { label: 'Not Reachable', value: 'NOT_REACHABLE' },
    { label: 'Confirm', value: 'CONFIRM' },
    { label: 'Not Interest', value: 'NOT_INTEREST' },
] as const;

// Default outcome options (for backward compatibility)
export const FOLLOW_UP_OUTCOME_OPTIONS = [
    { label: 'Interested', value: 'INTERESTED' },
    { label: 'Not Interested', value: 'NOT_INTERESTED' },
    { label: 'Need Time', value: 'NEED_TIME' },
    { label: 'No Response', value: 'NO_RESPONSE' },
    { label: 'Not Reachable', value: 'NOT_REACHABLE' },
] as const;

// Filter Options
export const STATUS_FILTER_OPTIONS = FOLLOW_UP_STATUS_OPTIONS.map(option => ({
    label: option.label,
    value: option.value,
}));

export const TYPE_FILTER_OPTIONS = FOLLOW_UP_TYPE_OPTIONS.map(option => ({
    label: option.label,
    value: option.value,
}));

export const OUTCOME_FILTER_OPTIONS = FOLLOW_UP_OUTCOME_OPTIONS.map(option => ({
    label: option.label,
    value: option.value,
}));
